import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const Heartbeat: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Heartbeat" */ './Heartbeat.tsx')).Heartbeat,
});
